import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { commonStyles } from '../../styles';
export var searchBarContainer = function searchBarContainer(props) {
  return [{
    position: 'relative',
    zIndex: 50,
    width: '100%',
    borderRadius: 0
  }].concat(_toConsumableArray(commonStyles(props)));
};
export var searchBarInputContainer = function searchBarInputContainer(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 0,
    backgroundColor: theme.gray200VeryLight,
    border: "1px solid ".concat(theme.gray200)
  };
};
export var searchBarInput = {
  fontSize: '1.1rem',
  lineHeight: 1.2,
  paddingRight: '1rem',
  outline: 'none',
  padding: '0.8rem 1rem',
  border: 'none',
  background: 'transparent',
  borderRadius: 0,
  '&:focus, &:active': {
    border: 'none',
    boxShadow: 'none'
  }
};
export var searchBarInputIcon = {
  cursor: 'text',
  fontSize: 17,
  padding: '0.8rem 1rem 0.8rem 0'
};
export var searchBarSuggestionsContainer = function searchBarSuggestionsContainer(theme) {
  return {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    left: 0,
    right: 0,
    color: theme.gray200,
    maxHeight: 300,
    zIndex: 20,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    backgroundColor: theme.white,
    boxShadow: theme.boxShadow
  };
};
export var searchBarSuggestionItem = function searchBarSuggestionItem(theme) {
  return {
    padding: '0.8rem 1.5rem',
    color: theme.gray200,
    '&:focus, &:hover': {
      outline: 'none',
      backgroundColor: theme.primary,
      color: theme.gray300
    }
  };
};